'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CategoryHeader = require('./CategoryHeader.css');

var _CategoryHeader2 = _interopRequireDefault(_CategoryHeader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CategoryHeader(props) {
  return _react2.default.createElement(
    'div',
    { className: _CategoryHeader2.default.root },
    props.children
  );
}

exports.default = CategoryHeader;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CategoryHeader/CategoryHeader.jsx
// module id = 1449
// module chunks = 0